// -----------------------------------------------------------------
// List of callable cloud functions
// -----------------------------------------------------------------

export const FUNCTIONS = {
  SERVER_STATUS: "server_status",
  ZOOM_GET_SIGNATURE: "zoom_generateSignature",
  SEND_CONFIRMATION_EMAIL: "mail_sendConfirmationMail",
  SEND_RESET_PASSWORD_EMAIL: "mail_sendResetPasswordMail",
  LINKEDIN_REDIRECT: "linkedin_redirect",
  LINKEDIN_TOKEN: "linkedin_token",
  DELETE_USER: "user_delete",
  GET_MATTERMOST_TOKEN: "mattermost_auth",
  CREATE_MATTERMOST_USER: "mattermost_createUser",
  GET_STAND_CONTENT: "stand_getStaticContent",
  UPDATE_PASSWORD: "user_updatePrivatePassword",
};
